export default "__VITE_ASSET__BwIkFIkD__"